<template>
  <v-row no-gutters class="fill-height">
    <v-col class="d-flex flex-column align-stretch">
      <v-row style="max-height: 40px" no-gutters>
        <v-col>
          <theHeading ref="theHeading" :headingOverride="headingOverride">
            <template v-slot:tools>
              <go-back :text="'Planificació'" />
            </template>
          </theHeading>
        </v-col>
      </v-row>
      <kanban-judo
        ref="kanbanJudo"
        :service="service"
        :showChildren="showChildren"
        :showMedia="showMedia"
        :customFunctions="customFunctions"
        @setHeading="setHeading"
      />
    </v-col>
    <dialog-generacio-progressio
      :dialog="newGeneracioProgressioDialog"
      :nom-sessio="nomSessio"
      :id-sessio="idSessio"
      @toggleGeneracioProgressioDialog="
        newGeneracioProgressioDialog = !newGeneracioProgressioDialog
      "
    />
    <dialog-importacio-progressio
      :dialog="newImportacioProgressioDialog"
      :id-sessio="idSessio"
      :progressions="progressions"
      @toggleImportacioProgressioDialog="
        newImportacioProgressioDialog = !newImportacioProgressioDialog
      "
    />
  </v-row>
</template>

<script>
import ServiceFactory from "@/services/ServiceFactory"

export default {
  components: {
    kanbanJudo: () => import("@/components/judo/KanbanJudo"),
    theHeading: () => import("@/layouts/intranet/components/viewHeading"),
    DialogGeneracioProgressio: () => import("@/views/mesocicles/DialogGeneracioProgressio"),
    DialogImportacioProgressio: () => import("@/views/mesocicles/DialogImportacioProgressio"),
    goBack: () => import("@/components/BackButton"),
  },
  data() {
    return {
      service: ServiceFactory.get("mesocicles"),
      showChildren: true,
      showMedia: true,
      headingOverride: "",
      newGeneracioProgressioDialog: false,
      newImportacioProgressioDialog: false,
      nomMesocicle: "",
      nomSessio: "",
      idSessio: null,
      progressions: [],
      customFunctions: {
        downloadPdf(sessio_id) {
          const SessioService = ServiceFactory.get("sessions")
          SessioService.getPdf(sessio_id).then(response => {
            const link = document.createElement("a")
            link.href = "data:application/octet-stream;base64," + response.data.binary
            link.download = response.data.filename + ".pdf"
            link.dispatchEvent(new MouseEvent("click"))
          })
        },
        cloneSessio: sessio_id => {
          const SessioService = ServiceFactory.get("sessions")
          SessioService
            .clone(sessio_id)
            .then(() => {
              this.$refs["kanbanJudo"].loadKanban()
            })
            .catch(error => {
              this.$notifyErrorByStatusCode(error.response.status)
            })
        },
        generateProgressio: (sessio_id, sessio_nom) => {
          this.newGeneracioProgressioDialog = true
          this.nomSessio = sessio_nom
          this.idSessio = sessio_id
        },
        importProgressio: sessio_id => {
          const ProgressionService = ServiceFactory.get("progressions")
          ProgressionService
            .getListItems()
            .then(response => {
              this.progressions = response.data
              this.newImportacioProgressioDialog = true
              this.idSessio = sessio_id
            })
            .catch(error => {
              this.$notifyErrorByStatusCode(error.response.status)
            })
        },
      },
    }
  },
  methods: {
    setHeading(name) {
      this.$refs.theHeading.heading = name
    },
  },
}
</script>

<style lang="scss" scoped></style>
